
import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const ContactoPage = () => {
  useEffect(() => {
    document.title = 'Contacto - Solicita tu Presupuesto Gratis | JUSTCLEAN Castelldefels';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Contacta con JUSTCLEAN Castelldefels para vaciado de pisos y limpieza extrema. Presupuesto gratis sin compromiso. ☎️ 602 36 59 96 | WhatsApp disponible 24/7');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "name": "Contacto - JUSTCLEAN Castelldefels",
      "description": "Contacta con JUSTCLEAN Castelldefels para vaciado de pisos y limpieza extrema. Presupuesto gratis sin compromiso.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://castelldefels.justclean.es'}/contacto`,
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "JUSTCLEAN CASTELLDEFELS",
        "telephone": "+34602365996",
        "email": "info@castelldefels.justclean.es",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Passeig Marítim 234",
          "addressLocality": "Castelldefels",
          "addressRegion": "Barcelona",
          "postalCode": "08860",
          "addressCountry": "ES"
        },
        "openingHours": "Mo-Su 00:00-23:59"
      }
    });
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="pt-20">
        <ContactHero />
        <div className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
};

export default ContactoPage;
